

/**
 * Removes stray Bootstrap/Reactstrap modal artifacts. If `modal-open` or `.modal-backdrop`
 * is left on the document after navigation, the UI looks dimmed and does not accept clicks.
 */
export function cleanupBootstrapModalArtifacts() {
  if (typeof document === 'undefined') {
    return;
  }
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
  // Some modal libraries set this with setProperty; remove explicit CSS key as well.
  document.body.style.removeProperty('padding-right');
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
}
